import { ReactNode, useState } from 'react';
import { CSSTransition } from 'react-transition-group';
import styled, { css } from 'styled-components';
import { useMobile } from '../../../common/services/screenSize/ScreenSizeService';
import { ThemeColours } from '../../../common/styles/ThemeColours';
import { prop } from '../../../common/util/prop';
import { OVERLAY_ANIMATION_DURATION } from '../../constants';
import { useOverlay } from './OverlayContext';

export const DROPDOWN_WIDTH = 400;

export const DROPDOWN_VERTICAL_PADDING = 16;

export const Dropdown = ({ children }: { children?: ReactNode }) => {
  const mobile = useMobile();
  const { x, y, fixedMobileHeight, activeId } = useOverlay();
  const [coordinates] = useState({ x, y });

  return (
    <>
      {mobile && (
        <CSSTransition
          appear={Boolean(activeId)}
          in={Boolean(activeId)}
          timeout={OVERLAY_ANIMATION_DURATION}
        >
          <DropDownMobileBox fixedHeight={fixedMobileHeight}>{children}</DropDownMobileBox>
        </CSSTransition>
      )}
      {!mobile && (
        <CSSTransition
          appear={Boolean(activeId)}
          in={Boolean(activeId)}
          timeout={OVERLAY_ANIMATION_DURATION}
        >
          <DropDownDesktopBoxOuter x={coordinates.x} y={coordinates.y}>
            <DropDownDesktopBox>{children}</DropDownDesktopBox>
          </DropDownDesktopBoxOuter>
        </CSSTransition>
      )}
    </>
  );
};

export const DropDownDesktopBox = styled.div`
  background-color: ${ThemeColours.white};
  border-radius: 8px;
  color: ${ThemeColours.black};
  max-height: 100%;
  overflow: auto;
  padding: ${DROPDOWN_VERTICAL_PADDING}px 0;
  width: 100%;
`;

export const DropDownDesktopBoxOuter = styled.div<{ x: number; y: number }>`
  bottom: 16px;
  display: flex;
  flex-direction: column;
  left: ${prop('x')}px;
  overflow: hidden;
  padding-top: 80px;
  position: absolute;
  top: ${prop('y')}px;
  width: ${DROPDOWN_WIDTH}px;

  &.appear {
    opacity: 0;
  }

  &.appear-active {
    opacity: 1;
    transition: opacity ${OVERLAY_ANIMATION_DURATION}ms;
  }

  &.exit {
    opacity: 1;
  }

  &.exit-active {
    opacity: 0;
    transition: opacity ${OVERLAY_ANIMATION_DURATION}ms;
  }
`;

export const DropDownMobileBox = styled.div<{ fixedHeight?: boolean }>`
  background-color: ${ThemeColours.white};
  border-radius: 16px 16px 0px 0px;
  bottom: 0px;
  color: ${ThemeColours.black};
  left: 0px;
  ${props =>
    props.fixedHeight
      ? css`
          height: 80%;
        `
      : css`
          max-height: 80%;
        `}
  overflow-y: auto;
  padding: ${DROPDOWN_VERTICAL_PADDING}px 0;
  position: absolute;
  width: 100%;

  &.appear {
    transform: translateY(100%);
  }

  &.appear-active {
    transform: translateY(0);
    transition: transform ${OVERLAY_ANIMATION_DURATION}ms;
  }

  &.exit {
    transform: translateY(0);
  }

  &.exit-active {
    transform: translateY(100%);
    transition: transform ${OVERLAY_ANIMATION_DURATION}ms;
  }
`;
